export default __webpack_public_path__ + "static/media/work_first.d9283290.png";